export const environment = {
    production: false,
    idmUrl: 'https://idm.dev.zsservices.com/CDS/IdentityManager/app/Web/Login.aspx?ReturnUrl=https://dev.cds.zsservices.com/projects',
    organization: 'MERCK',
    accessRequestUrl : '',
    mailDl :''
  
  };
  